// noinspection HtmlUnknownAttribute

import createElement from "../createElement";

function initGridFooter(options) {
	const gridContainer = options._domElement;

	// Add footer related methods to grid wrapper
	options._getRowName = getRowName;
	options._getPageCount = getPageCount;
	options._updateFooter = updateFooter;
	options._nextPage = nextPage;
	options._prevPage = prevPage;

	let rowName = options._getRowName();

	// Initialize footer
	let footer;

	if (options._pagination) {
		footer = createElement(`
            <div aria-live="polite" class="ag-paging-panel ag-unselectable">
                <span class="ag-paging-row-summary-panel" aria-hidden="true">
                    <span class="ag-paging-row-summary-panel-number start-row"></span>
                    <span>to</span>
                    <span class="ag-paging-row-summary-panel-number end-row"></span>
                    <span>of</span>
                    <span class="ag-paging-row-summary-panel-number total-row-count"></span>
                    <span class="row-name">${rowName}</span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div ref="btPrevious" class="ag-paging-button prev-page" role="button" aria-label="Previous Page" tabindex="0"><span class="ag-icon ag-icon-previous" role="presentation"></span></div>
                    <span class="ag-paging-description" aria-hidden="true">
                        <span>page</span>
                        <span class="current-page"></span>
                        <span>of</span>
                        <span class="last-page"></span>
                    </span>
                    <div ref="btNext" class="ag-paging-button next-page" role="button" aria-label="Next Page" tabindex="0"><span class="ag-icon ag-icon-next" role="presentation"></span></div>
                </span>
            </div>
        `)

		// Add page listeners
		footer.querySelector('.next-page').onclick = () => options._nextPage();
		footer.querySelector('.prev-page').onclick = () => options._prevPage();
	} else {
		// No pagination just show total number of elements
		footer = createElement(`
            <div aria-live="polite" class="ag-paging-panel ag-unselectable">
                <span class="ag-paging-row-summary-panel" aria-hidden="true">
                    <span class="ag-paging-row-summary-panel-number total-row-count">?</span>
                    <span class="row-name">${rowName}</span>
                </span>
            </div>
        `)
	}

	// Add new footer to grid
	const gridBodyWrapper = gridContainer.querySelector('.ag-root-wrapper');

	gridBodyWrapper.appendChild(footer);
}

function getRowName() {

	let rowName = this._rowName ? this._rowName : 'rows';

	if (this._totalRows && this._totalRows === 1) {
		// Attempt to singularize row name
		if (rowName.slice(rowName.length - 1) === 's') {
			rowName = rowName.slice(0, rowName.length - 1);
		}
	}

	return rowName
}

function getPageCount() {
	if (this._totalRows) {
		let pages = this._totalRows / this.paginationPageSize;
		if (Number.isInteger(pages)) {
			return Math.floor(pages);
		} else {
			return Math.floor(pages) + 1;
		}
	}

	return 0;
}

function nextPage() {

	if (this._getPageCount()) {
		// If there pages to begin with
		if (this._currentPage < (this._getPageCount() - 1)) {
			// If we have not reached the end
			this._currentPage = this._currentPage + 1;
			this._setPage(this._currentPage);
			this._turnOffAutoRefresh();
		}
	}
}

function prevPage() {
	if (this._getPageCount()) {
		// If there pages to begin with
		if (this._currentPage > 0) {
			// If we have not reached the end
			this._currentPage = this._currentPage - 1;
			this._setPage(this._currentPage);
			this._turnOffAutoRefresh();
		}
	}
}

function updateFooter() {
	if (this._pagination) {
		let startRow = this._currentPage * this.paginationPageSize;
		let endRow = startRow + this.paginationPageSize;

		if (endRow > this._totalRows) {
			endRow = this._totalRows;
		}

		// Set row numbers
		this._domElement
			.querySelector('.ag-paging-panel .start-row')
			// Add one only if there are actual rows to show
			.innerText = endRow ? startRow + 1 : startRow;
		this._domElement
			.querySelector('.ag-paging-panel .end-row')
			.innerText = endRow;

		this._domElement
			.querySelector('.ag-paging-panel .total-row-count')
			.innerText = this._totalRows;

		// Set page numbers
		this._domElement
			.querySelector('.ag-paging-panel .current-page')
			.innerText = this._currentPage + 1;

		this._domElement
			.querySelector('.ag-paging-panel .last-page')
			.innerText = this._getPageCount();

	} else {
		// Set row count
		this._domElement
			.querySelector('.ag-paging-panel .total-row-count')
			.innerText = this._totalRows;
	}

	// Set row name
	this._domElement
		.querySelector('.ag-paging-panel .row-name')
		.innerText = this._getRowName();
}

export {initGridFooter}
